module.exports = __webpack_public_path__ + "img/sessionLeftImg.f6f2f7e3.png";